module.exports = __webpack_public_path__ + "static/media/course_01.529a0f06.jpg";